import { render, staticRenderFns } from "./StickerMenu.vue?vue&type=template&id=9565bad4&scoped=true&"
import script from "./StickerMenu.vue?vue&type=script&lang=js&"
export * from "./StickerMenu.vue?vue&type=script&lang=js&"
import style0 from "./StickerMenu.vue?vue&type=style&index=0&id=9565bad4&prod&scoped=true&lang=css&"
import style1 from "./StickerMenu.vue?vue&type=style&index=1&id=9565bad4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9565bad4",
  null
  
)

export default component.exports